<div id="bonelossSnapshotChartRoot"
[style.width]="hostWidth" [style.height]="hostWidth">
  <koa-risk-chart [level]="chartLevel" [riskScore]="chartScore"></koa-risk-chart>
</div>
